export default class TravelInsurance {
    constructor(data) {
        Object.defineProperty(this, "offers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.offers = data.offers;
    }
}
